import { render, staticRenderFns } from "./portalSearchResultComp.vue?vue&type=template&id=2ff280e3&scoped=true&%3Akey=%60search-%24%7BsearchKey%7D%60"
import script from "./portalSearchResultComp.vue?vue&type=script&lang=js"
export * from "./portalSearchResultComp.vue?vue&type=script&lang=js"
import style0 from "./portalSearchResultComp.vue?vue&type=style&index=0&id=2ff280e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff280e3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VAlert,VBtn,VBtnToggle,VContainer,VIcon,VImg,VLayout,VSheet})
